import { PaymentStatus } from '@erp/shared-types';
import { parseDateOnly } from '@/utils/dateUtils';

/**
 * What the payment badge says. `overdue` is not a stored status: it is an
 * unpaid (or partly paid) invoice whose due date has passed, and it is the
 * only payment state that earns red — unpaid on its own is the normal state
 * of the AP queue, not a problem.
 */
export type PaymentStatusDisplay =
  'paid' | 'partially_paid' | 'unpaid' | 'overpaid' | 'overdue' | 'unknown';

function startOfDay(date: Date): number {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  ).getTime();
}

export function resolvePaymentStatusDisplay({
  status,
  dueDate,
  today = new Date(),
}: {
  status: string;
  /** DATEONLY or ISO string. Missing means "never overdue". */
  dueDate?: string | null;
  today?: Date;
}): PaymentStatusDisplay {
  const outstanding =
    status === PaymentStatus.UNPAID || status === PaymentStatus.PARTIALLY_PAID;
  if (outstanding && dueDate) {
    const due = parseDateOnly(dueDate);
    if (due && startOfDay(due) < startOfDay(today)) return 'overdue';
  }
  switch (status) {
    case PaymentStatus.PAID:
    case PaymentStatus.PARTIALLY_PAID:
    case PaymentStatus.UNPAID:
    case PaymentStatus.OVERPAID:
      return status;
    default:
      return 'unknown';
  }
}
